module.exports = __webpack_public_path__ + "img/home-visual-03_m.130b62c4.png";